import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

interface Props {
  active: string
}

export const SortOptions: React.FC<Props> = ({ active }) => (
  <>
    <DropdownMenu.Button
      title="Alphabetically"
      id="abc"
      active={active === 'abc'}
    />
    <DropdownMenu.Button
      title="Date created"
      id="created"
      active={active === 'created'}
    />
    <DropdownMenu.Button
      title="Last updated"
      id="updated"
      active={active === 'updated'}
    />
  </>
)
